import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";

import React from "react";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import faIR from "antd/es/locale-provider/fa_IR";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import "./styles/index.scss";

ReactDOM.render(
	<ConfigProvider locale={faIR}>
		<App />
	</ConfigProvider>,
	document.getElementById("root") as HTMLElement,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

if (process.env.NODE_ENV === "production") {
	serviceWorker.register({
		onUpdate() {
			const newUpdateEvent = new Event("newContentAvailble");

			window.dispatchEvent(newUpdateEvent);
		},
	});
} else {
	serviceWorker.unregister();
}
